/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { computeServicesListServiceEvents } from "../../funcs/computeServicesListServiceEvents.js";
import * as operations from "../../models/operations/index.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: operations.ListServiceEventsRequest$inboundSchema,
};

export const tool$computeServicesListServiceEvents: ToolDefinition<
  typeof args
> = {
  name: "compute-services-list-service-events",
  description: `List service events`,
  args,
  tool: async (client, args, ctx) => {
    const [result, apiCall] = await computeServicesListServiceEvents(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    const value = result.value;

    return formatResult(value, apiCall);
  },
};
